import { authRoles } from 'app/auth';
import i18next from 'i18next';
import NotificationTable from './table/NotificationTable';
import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'notification', en);
i18next.addResourceBundle('hu', 'notification', hu);

export default [
	{
		path: '/notification/:sessionNameParam?',
		component: NotificationTable,
		auth: authRoles.notifications
	}
];
